import { render, staticRenderFns } from "./ConsultaStockMovimientosArma.vue?vue&type=template&id=f4732cb6"
import script from "./ConsultaStockMovimientosArma.vue?vue&type=script&lang=js"
export * from "./ConsultaStockMovimientosArma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports